class Shop {
    static path = 'variables/shop';
    static vueMethods = {
        'triggerShopPicker': ({bucket1, node}) => {
            window.VueApp.$modal.show('litegraph-item-picker');
        },
        'saveShopPicker': ({item, node}) => {
            let data = item.split(' - ');
            let shopID = data[0];
            node.properties.value = item.slice(shopID.length + 3);
            node.properties.shopID = parseInt(shopID)
            window.VueApp.$modal.hide('litegraph-item-picker');
        }
    }

    constructor(mutator) {
        this.addOutput("value", "shop,model");
        // this.widgets_up = true;
        this.bgcolor = '#fd754b';
        this.title = 'Xerocraft Shop';
        this.desc = 'Select a shop';
        this.properties = {value: '', shopID: 0, modelProperties: window.triggerInfo.models['shop']}

        if(window.VueApp.container.graphStatus !== 'read_only') {
            this.addWidget("button", "Select Shop", null, (v) => {
                window.VueApp.$refs.triggerBuilder.itemPickerType = 'Shop';
                window.VueApp.$refs.triggerBuilder.runNodeMethod('triggerShopPicker', {
                    bucket1: this.properties.shopID & ' - ' & this.properties.value,
                    node: this
                }, true);
            });
        }

    }

    onExecute() {
        this.setOutputData(0, this.properties["value"]);
    }

    getTitle() {
        if (this.flags.collapsed) {
            return this.properties.value;
        }
        return this.title;
    }

    onDrawBackground() {
        //show the current value
        this.outputs[0].label = this.properties["value"];
    }
}

module.exports = Shop
